import { Component, OnInit } from '@angular/core';
import { interval } from 'rxjs';
import { CommonService } from 'src/app/core/services/common.service';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit {
  year: number = new Date().getFullYear();
  view: number = parseFloat(this.localStorageService.getItem("view"))
  constructor(private localStorageService: LocalStorageService,public commonService : CommonService) { }

  ngOnInit() {
    interval(180000).subscribe(x => {
      this.commonService.getData("api/get_view").subscribe((responseResult: any) => {
        this.view = parseFloat(responseResult)
      });
  });
  }
}